const VoucherStatusType = {
    USING_EXPIRED: 1,
    INACTIVE: 0,
    ISSUING: 2,
    ACTIVATED: 3,
    USED: 4,
    WAITING: 5,
    DISTRIBUTION_EXPIRED: 7,
    LOCKED_USING: 12
}
export default VoucherStatusType
